/**
 * Legacy layout wrapper — BaaS now uses PrivateApp shell + nested MenuNavigation.
 * Kept as a pass-through for any remaining imports.
 */
export const BaasConsoleLayout = ({ children }) => (
  <div className="baas-console min-w-0">{children}</div>
);
